import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { Theme } from "../../../../types/theme.types";

const { get } = request;
const { Bearer } = AUTHORIZATION;
const initialRoute = "admin/employee-page-design/preview";

type ThemePreview = Theme & {
	_id?: string;
	__v?: number;
	user_id: string;
	group_number: number;
};

type Params = {
	user_id: string;
	group_number: number;
};

export const getThemeColorsByGroupNumberAndUserId = async (params: Params): Promise<ThemePreview> => {
	try {
		const endpoint = `${initialRoute}/theme-color/group-and-user`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `${Bearer} ${token}`
			},
			params
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				if (result) {
					// console.log("result", result);
					return result;
				} else {
					const theme: ThemePreview = {
						primary_color: "#e0e0e0",
						secondary_color: "#4e4e4e",
						button: {
							background_color: "#e0e0e0",
							color: "#000000"
						},
						top_bar: {
							color: "#fffff",
							background_color: "#7e7e7e"
						},
						theme_style: "theme_style_1",
						group_number: params.group_number,
						user_id: params.user_id
					};
					return theme;
				}
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const themePreview = {
	getThemeColorsByGroupNumberAndUserId
};
